<div class="idp__iconbanner idp__iconbanner--wrapper">
  <div
    class="banner-row banner-row-container idp__iconbanner--container"
    [ngClass]="bannerRowClass"
    [ngStyle]="styles?.banner!"
  >
    <ng-container *ngIf="desktopBannerEnabled">
      <div
        class="idp__iconbanner--imageplaceholder idp__iconbanner--desktop banner-d-sm-none banner-d-md-block banner-col-1 text-align-center"
      >
        <idp-image
          class="idp__iconbanner--image-desktop"
          [content]="content.imageContent?.desktop!"
        ></idp-image>
      </div>
    </ng-container>

    <ng-container *ngIf="mobileBannerEnabled">
      <div
        class="idp__iconbanner--imageplaceholder idp__iconbanner--mobile banner-d-none banner-d-sm-block banner-d-md-none banner-col-1 text-align-center"
      >
        <idp-image
          class="idp__iconbanner--image-mobile"
          [content]="content.imageContent?.mobile!"
        ></idp-image>
      </div>
    </ng-container>

    <div class="idp__iconbanner--content banner-col-11">
      <div class="banner-row margin-0">
        <div
          class="banner-col-xs-12 banner-col-sm-12 banner-col-md-auto padding-0 margin-auto"
        >
          <idp-heading
            *ngIf="!!content.headerText"
            [styles]="headerStyles"
            [content]="headerContent"
            class="idp__iconbanner--heading"
          ></idp-heading>
        </div>
        <ng-container *ngIf="!!content.description && !!styles.description">
          <div class="banner-col padding-0 idp__iconbanner--description">
            <idp-text
              class="idp__iconbanner--subheading"
              [styles]="styles.description"
              [content]="content.description"
            ></idp-text>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
